export const limit = 50;

export const localInfo = localStorage.getItem("userType");

export const ACCOUNT_ENUMS = {
  ADMIN: "ADMIN",
  EMPLOYEE: "EMPLOYEE",
};

export const userType = localInfo ? localInfo : "";
export const isAdmin = userType === ACCOUNT_ENUMS?.ADMIN;
export const isEmployee = userType === ACCOUNT_ENUMS?.EMPLOYEE;

export const PermissionsList = {
  ALL_ACCESS: {
    title: 'Super admin',
    description: 'Super admin can do everything',
    code: 0,
  },
};
